import { g as getCookieHandler } from "../../../cookieHandler-ac6954c1.js";
import { logger } from "../../../utils/logger.es.js";
import { timeCalculation } from "../timeOnPage/timeOnPage.es.js";
import { EH_VISIT_ID, EH_VISIT_TS } from "./constants.es.js";
import { processUrlVisitId } from "./processUrlVisitId.es.js";
import { getUrlVisitId, timeExpiredCheck } from "./utils.es.js";
import { v as v4 } from "../../../v4-88c20f3b.js";
import "./adapter.es.js";
import "../../../cookies-04bd2321.js";
const getVisitId = (adapter) => {
  try {
    const cookieHandler = getCookieHandler(adapter);
    const { urlVisitId, urlVisitIdTs } = getUrlVisitId();
    const cookieOptions = cookieHandler.getCookieOptions();
    const cookies = cookieHandler.parseCookies();
    const visitId = cookies[EH_VISIT_ID] || null;
    if (urlVisitId) {
      return processUrlVisitId(
        cookies,
        urlVisitId,
        cookieOptions,
        cookieHandler,
        urlVisitIdTs
      );
    } else if (visitId) {
      const currentTime = /* @__PURE__ */ new Date();
      const visitIdSetTime = new Date(cookies[EH_VISIT_TS]) || null;
      const timeDifference = !cookies[EH_VISIT_TS] ? 1900 : timeCalculation(currentTime, visitIdSetTime);
      cookieHandler.setCookie({ [EH_VISIT_TS]: (/* @__PURE__ */ new Date()).toString() }, [cookieOptions]);
      return timeExpiredCheck(
        timeDifference,
        visitId,
        cookieOptions,
        cookieHandler
      );
    } else {
      const firstVisitId = v4();
      cookieHandler.setCookie(
        {
          [EH_VISIT_ID]: firstVisitId,
          [EH_VISIT_TS]: (/* @__PURE__ */ new Date()).toString()
        },
        [cookieOptions, cookieOptions]
      );
      return firstVisitId;
    }
  } catch (error) {
    logger.error("Error getting Visit Id", error);
    return null;
  }
};
export {
  getVisitId
};
